<template>
  <v-card>
    <v-card-title style="align-items: center"
      >Remarks
      <v-spacer />
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-textarea v-model="remarks" auto-grow outlined rows="2" />
    </v-card-text>
    <v-card-actions class="d-flex justify-end">
      <v-btn @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { readTimeTables } from '@/api/timetable';
import api from '@/api';
import { crudUpdate } from '@/api/crud';
import { getOid } from '@/services/utils';

export default {
  name: 'RemarksDialog',
  props: {
    id: String,
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  data() {
    return {
      docs: null,
      remarks: null,
    };
  },
  methods: {
    async save() {
      try {
        await crudUpdate(api, 'rml/admin/bookings', getOid(this.docs.booking), {
          remarks: this.remarks,
        });
        this.$emit('update', this.id);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.close();
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async reload() {
      try {
        this.docs = await readTimeTables(api, this.id, { populate: ['booking'] });
        this.remarks = this.docs?.booking?.remarks;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
  },
};
</script>

<style scoped></style>
